<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Detail Transaksi QRIS</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div>
                <div
                    class="section detail-transaction-section pt-4"
                    style="--height: 150px"
                >
                    <div class="detail-card">
                        <div class="listed-detail mt-1">
                            <div
                                class="icon-wrapper"
                                v-if="
                                    qris_payments_detail.status == 'COMPLETED'
                                "
                            >
                                <div class="iconbox bg-success">
                                    <ion-icon
                                        name="checkmark-outline"
                                    ></ion-icon>
                                </div>
                            </div>

                            <div class="text-center mt-2">
                                <h3 class="mb-0">
                                    {{
                                        qris_payments_detail.qris_merchant
                                            .merchant_name
                                    }}
                                </h3>
                                <div>
                                    <small>Terima Pembayaran Sebesar</small>
                                </div>
                                <h1
                                    class="text-center"
                                    style="font-weight: bold"
                                >
                                    Rp
                                    {{ qris_payments_detail.amount | rupiah }}
                                </h1>
                            </div>
                        </div>
                        <div class="listed-detail mt-1">
                            <table class="table-detail">
                                <tr>
                                    <td width="150px" class="label-td">
                                        Merchant ID (NMID)
                                    </td>
                                    <td width="20px">:</td>
                                    <td
                                        class="label-td"
                                        style="word-wrap: break-word"
                                    >
                                        <b>{{
                                            qris_payments_detail.qris_merchant
                                                .merchant_id
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Tanggal & Waktu
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        {{
                                            qris_payments_detail.paid_ta | date
                                        }}
                                        ({{
                                            qris_payments_detail.paid_ta | time
                                        }}
                                        WIB)
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Nominal
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <b
                                            >Rp
                                            {{
                                                qris_payments_detail.amount
                                                    | rupiah
                                            }}</b
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Issuer
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        {{
                                            qris_payments_detail.reference_data
                                                .issuer
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">RRN</td>
                                    <td width="20px">:</td>
                                    <td
                                        class="label-td"
                                        style="word-wrap: break-word"
                                    >
                                        {{
                                            qris_payments_detail.reference_data
                                                .rrn
                                        }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="listed-detail mt-1">
                            <blockquote class="blockquote p-1 mt-2 mb-1">
                                <h5 class="mb-0 ml-1">Detail Pencairan</h5>
                            </blockquote>
                            <table class="table-detail">
                                <tr>
                                    <td width="150px" class="label-td">
                                        Status Pencairan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <label
                                            class="badge badge-warning pl-2 pr-2"
                                            v-if="
                                                qris_payments_detail
                                                    .qris_settlement.status ==
                                                'waiting'
                                            "
                                            >Menunggu</label
                                        >
                                        <label
                                            class="badge badge-primary pl-2 pr-2"
                                            v-else-if="
                                                qris_payments_detail
                                                    .qris_settlement.status ==
                                                'process'
                                            "
                                            >Sedang Diproses</label
                                        >
                                        <label
                                            class="badge badge-success pl-2 pr-2"
                                            v-else-if="
                                                qris_payments_detail
                                                    .qris_settlement.status ==
                                                'success'
                                            "
                                            >Berhasil</label
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Estimasi Pencairan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        {{
                                            qris_payments_detail.qris_settlement
                                                .settlement_date | date
                                        }}
                                        ({{
                                            qris_payments_detail.qris_settlement
                                                .settlement_date | time
                                        }}
                                        WIB)
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Jenis Pencairan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <div
                                            v-if="
                                                qris_payments_detail
                                                    .qris_settlement
                                                    .settlement_type ==
                                                'early_settlement'
                                            "
                                            class="text-warning"
                                        >
                                            <ion-icon
                                                name="flash-outline"
                                            ></ion-icon>
                                            Dipercepat
                                        </div>
                                        <div v-else class="text-secondary">
                                            Normal
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Biaya MDR (Fee)
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        Rp
                                        {{ qris_payments_detail.fee | rupiah }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Biaya Percepatan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        Rp
                                        {{
                                            qris_payments_detail.fee_fast_settlement
                                                | rupiah
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px">Jumlah Dicairkan</td>
                                    <td width="20px" class="label-td">:</td>
                                    <td class="label-td">
                                        <b
                                            >Rp
                                            {{
                                                qris_payments_detail.amount_disbursed
                                                    | rupiah
                                            }}</b
                                        >
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisPaymentDetail(this.$route.params.id).then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_payments_detail: state => state.qris_payments_detail,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', ['getQrisPaymentDetail']),
            ...mapMutations('qrisMerchant', ['RESET_QRIS_PAYMENT_DETAIL']),
        },

        mounted() {},
        destroyed() {
            this.RESET_QRIS_PAYMENT_DETAIL();
        },
    };
</script>
